import { Box, Typography } from '@mui/material'
import dayjs from 'lib/dayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DateRangePickerV2Props } from './DateRangePickerV2.types'
import styles from './DateRangePickerV2.module.scss'

export const DateRangePickerV2 = ({
  startDate,
  endDate,
  onChange,
  minDate = undefined,
  maxDate = undefined,
}: DateRangePickerV2Props) => {
  return (
    <Box className={styles.container}>
      <DatePicker
        data-testid={'date-range-picker-v2-start'}
        minDate={minDate ? dayjs(minDate) : undefined}
        maxDate={maxDate ? dayjs(maxDate) : undefined}
        label="Start Date"
        value={startDate ? dayjs(startDate) : null}
        onChange={(start) => {
          if (start) onChange(start.toDate(), endDate)
        }}
        reduceAnimations
        slotProps={{
          textField: { size: 'small', className: styles.textField },
          desktopPaper: {
            className: styles.datePicker,
          },
          mobilePaper: {
            className: styles.datePicker,
          },
        }}
      />
      <Typography variant="subtitle1">to</Typography>
      <DatePicker
        data-testid={'date-range-picker-v2-end'}
        minDate={startDate ? dayjs(startDate).startOf('day') : undefined}
        maxDate={maxDate ? dayjs(maxDate) : undefined}
        label="End Date"
        value={endDate ? dayjs(endDate) : null}
        onChange={(end) => {
          if (end) onChange(startDate, end.toDate())
        }}
        reduceAnimations
        slotProps={{
          textField: { size: 'small', className: styles.textField },
          desktopPaper: {
            className: styles.datePicker,
          },
          mobilePaper: {
            className: styles.datePicker,
          },
        }}
      />
    </Box>
  )
}
